var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLangIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.5H3C1.9 1.5 1 2.4 1 3.5V15.5L4 12.5H9V11.5C9 9.3 10.79 7.5 13 7.5V3.5C13 2.4 12.1 1.5 11 1.5ZM11 4.5H9.5C9.16 5.69 8.54 6.8 7.68 7.76L7.66 7.78L8.92 9.03L8.55 10.04L7 8.5L4.5 11L3.81 10.27L6.34 7.78C5.72892 7.10326 5.22935 6.33365 4.86 5.5H5.85C6.16 6.1 6.54 6.67 7 7.18C7.69995 6.40259 8.23415 5.49071 8.57 4.5H3V3.5H6.5V2.5H7.5V3.5H11V4.5ZM21 9.5H13C11.9 9.5 11 10.4 11 11.5V18.5C11 19.6 11.9 20.5 13 20.5H20L23 23.5V11.5C23 10.4 22.1 9.5 21 9.5ZM19.63 19.5L18.78 17.25H15.22L14.38 19.5H12.88L16.25 10.5H17.75L21.13 19.5H19.63ZM17 12.5L18.22 15.75H15.79L17 12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangIcon);
export default __webpack_public_path__ + "static/media/lang-icon.eaa7c791695f086b83d258a4edfb269b.svg";
export { ForwardRef as ReactComponent };